import { cleanArray } from 'helpers/array'
import { NEW_RECORD_PATH } from 'config/consts'
import { useParams } from 'react-router-dom'

const useRouterState = ({ location: { newRecordAdded, copyId, pathname }, history, sections, baseUrl, replaceOnlyIdOnRoute, client, sectionPathRedirect = true }) => {
	const { section = '', subsection: routerSubsection = '', id: routerId } = useParams()
	const sectionData = sections.find(({ link }) => link === section) || {}
	const subsectionArr = sectionData.subsections || []
	const regExpString = cleanArray(subsectionArr.map(({ link }) => link)).join('|')
	const subsectionRegex = new RegExp((regExpString === '' ? /^\s$/ : regExpString), 'i')
	const isSubsectionMatched = subsectionRegex.test(routerSubsection || '')
	const subsection = isSubsectionMatched ? routerSubsection : ''
	const recordId = (!isSubsectionMatched && routerSubsection && !routerId) ? routerSubsection : routerId
	const subsectionData = subsectionArr.filter(({ link }) => link === `${subsection}`)[0] || {}
	const isNewRecord = recordId === NEW_RECORD_PATH && !newRecordAdded

	if (isNewRecord) {
		sectionData.subsections = subsectionArr.map(s => ({ ...s, disabled: true }))
		sectionData.allFields = subsectionArr.reduce((allFields, { fields }) => allFields.concat(fields), [])
	} else {
		sectionData.subsections = subsectionArr.map(s => ({ ...s, disabled: false }))
	}

	const getRouteById = itemId => {
		if (replaceOnlyIdOnRoute) {
			return routerId ? pathname.replace(routerId, itemId) : `${pathname}/${itemId}`
		}
		return `${baseUrl ? baseUrl : ''}/${section}${subsection ? `/${subsection}` : ''}/${itemId || ''}`
	}
	const selectRecord = id => {
		history.push({
			pathname: getRouteById(id)
		})
	}

	return {
		recordId,
		subsection,
		section,
		sectionData,
		subsectionData,
		isNewRecord,

		selectRecord,
		getRouteById
	}
}

export default useRouterState
